var isCustomLocation = document.getElementById("IsCustomLocation");
var isBasic = document.getElementById("IsBasic");
isBasic = isBasic && isBasic.value === "True";
isCustomLocation = isCustomLocation && isCustomLocation.value === "True";
var isComingSoon = document.querySelector("[data-is-coming-soon]")
  ? document.querySelector("[data-is-coming-soon]").value === "True"
  : false;

function formValuesToQueryString(data) {
  var queryString = "";
  var keyValuePair = Object.entries(data);
  if (keyValuePair && keyValuePair.length > 0) {
    for (var i = 0; i < keyValuePair.length; i++) {
      if (typeof keyValuePair[i][1] !== "undefined") {
        queryString += keyValuePair[i][0] + "=" + keyValuePair[i][1] + "&";
      }
    }
  }
  queryString = queryString.substring(0, queryString.length - 1);

  return queryString;
};

function showThankYouPageForExternalLeads(event) {
  var data = getFreeBrochureData(event);
  var url = "/getthankyoupageafterexternallead?" + formValuesToQueryString(data);
  window.NewHomeSource.ModalLoader.showModal(url);
}

function onChangeToggleZipInput(checkboxElem) {
  var form = checkboxElem.closest("form");
  var zipInput = form.querySelector("[name='postal']");

  if (checkboxElem.checked) {
    zipInput.disabled = true;
    zipInput.value = "";
  } else {
    zipInput.disabled = false;
  }
}

/**
 * Opens the custom scheduler, if the community is part of the scheduler program.
 * @param {HTMLElement} element The element triggering the form sending.
 */
function openScheduler(element) {
  const isCustomScheduler = element.dataset.component === 'lead-by-iframe';

  if (isCustomScheduler && window.NewHomeSource.SchedulerHandler) {
    window.NewHomeSource.SchedulerHandler.openSchedulerTab(element);
  }
}

async function onClickSendForm(event, callback) {
  event.preventDefault();
  NHS.loadCss(document.getElementById("detailsXpRecosCss").value);
  const buttonClicked = event.target.closest('[data-button-name-clicked]');
  document.body.dispatchEvent(new CustomEvent('lead-button-pressed', {
    detail: {
      buttonName: buttonClicked.dataset.buttonNameClicked
    }
  }));

  var currentForm = event.target.closest("form");
  const reCaptchaToken = new window.NewHomeSource.ReCaptchaToken();
  reCaptchaToken.initialize(currentForm);
  var sendButton = currentForm.querySelector("[data-send-form]");

  sendButton.disabled = true;
  var valid = await formValidator.validateForm(currentForm, true);

  if (valid) {
    const isValidRecaptcha = await reCaptchaToken.validate();
    reCaptchaToken.unbindEvents();
    if (!isValidRecaptcha) {
      sendButton.disabled = false;
      return;
    }
    document.body.dispatchEvent(new CustomEvent('valid-lead', {
      detail: {
        form: currentForm,
        formButton: sendButton,
      }
    }));

    sendButton.setAttribute("disabled", "disabled");

    if (isCustomLocation) {
      sendAskQuestionLead(event, callback);
    } else if (!isBasic){
      openScheduler(event.target);
      sendFreeBrochureLead(event, event.target, callback);
    }
  }
  reCaptchaToken.unbindEvents();
  sendButton.disabled = false;
}

function addDataInComment(formElem) {
  const commentElem = formElem.querySelector("textarea")
  let comment = commentElem ? commentElem.value : '';
  var isOnPageForm = formElem.getAttribute("data-onpage-form") === "";
  const isRegularLeadForm = formElem.getAttribute('data-regular-lead-form') === '';
  const isAskQuestionForm = formElem.getAttribute('data-is-ask-question-form') === '';
  var isFullImageViewer = formElem.parentElement.getAttribute("data-panel-form-type") === "scheduleTour";
  var commentData = "";

  if (isAskQuestionForm ||
    (isFullImageViewer && isComingSoon)) {
    return comment;
  }

  if (isOnPageForm) {
    commentData = getOnPageFormCommentData(formElem);
  } else if (isRegularLeadForm || isFullImageViewer) {
    commentData = getTourFormCommentData(formElem);
  }

  // if there is a users comment, appends the commentData at the end
  if (commentData !== "") {
    comment += comment === ""
      ? commentData
      : " - " + commentData;
  }

  return comment;
}

function getLeadAction(formTriggeredElement) {
  const isOnPageForm = formTriggeredElement.hasAttribute("data-onpage-form");
  let leadActionType = isOnPageForm ? " " : null;
  const isFullImageContactBuilder = formTriggeredElement.parentElement.getAttribute('data-panel-form-type') === 'contactBuilder';
  const isAskQuestion = formTriggeredElement.hasAttribute("data-is-ask-question-form");

  if (isFullImageContactBuilder || isAskQuestion) {
    return leadActionType;
  }

  if (!isOnPageForm) {
    const virtualTourElement = formTriggeredElement.querySelector("[data-is-virtual-tour]");

    if (virtualTourElement) {
      leadActionType = formTriggeredElement.querySelector("[data-is-virtual-tour]").checked ? "rva" : "ra";
    }
    else {
      leadActionType = "ra";
    }
  }

  return leadActionType;
}

/**
 * Gets the additional information that should be included in the comment field for the on page form.
 * @param {element} formElem The floating form element.
 * @returns The information that should be appended to the comment field.
 */
function getOnPageFormCommentData(formElem) {
  var formOptions = formElem.querySelectorAll("[name='form-options']:checked");
  var formText = "";

  for (var i = 0; i < formOptions.length; ++i) {
    var currentOption = formOptions[i];
    formText += formText === ""
      ? currentOption.getAttribute("data-comment") + ","
      : " " + currentOption.getAttribute("data-comment") + ",";
  }

  if (formText !== "") {
    formText = "Interested in: " + formText.slice(0, -1) + ".";
  }

  return formText;
}


/**
 * Get the data that should be appended to the comment field of the 'tour' forms.
 * This logic applies for the floating form tour form and the tour form in next steps section.
 * @param {any} formElement The form to handle.
 * @returns A string indicating if date and if the lead is a virtual tour or a 1 on 1 meeting.
 */
function getTourFormCommentData(formElement) {
  const virtualTourElement = formElement.querySelector("[data-is-virtual-tour]");
  const isVirtualTour = !!virtualTourElement && virtualTourElement.checked;
  let selectedDateElement = formElement.querySelector("[data-date]");
  let finalDate = '';

  if (selectedDateElement) {
    const selectedDate = selectedDateElement.getAttribute("data-date");
    finalDate = selectedDate.replace(/[^ -~]/g, '');
  }
  else {
    return '';
  }

  if (isVirtualTour) {
    return formElement.querySelector("[data-text-video-chat]").value + " " + finalDate;
  } else {
    return formElement.querySelector("[data-text-in-person]").value + " " + finalDate;
  }
}

/**
 * Gets the preferred method of contact selected in the form <select>, if any
 * @param {any} form Form element
 * @returns {string} The value of the selected dropdown, empty if the <select> doesn't exists.
 */
function getPreferredContactMethod(form) {
  const contactMethodInput = form.querySelector('[data-contact-method]');
  const selectedOption = contactMethodInput
    ? contactMethodInput.options[contactMethodInput.selectedIndex].value
    : '';

  return selectedOption;
}

/**
 * Gets the realtor question answer selected in the form <select>, if any
 * @param {any} form Form element
 * @returns {string} The value of the selected dropdown, empty if the <select> doesn't exists.
 */
function getRealtorQuestionAnswerId(form) {
  const realtorAnswerInput = form.querySelector('[data-realtor-answer]');
  const selectedOption = realtorAnswerInput
    ? realtorAnswerInput.options[realtorAnswerInput.selectedIndex].value
    : '';

  return selectedOption;
}

/**
 * Gets the preferred builder selected from the 'Preferred Builder' <select>, if any
 * @param {any} form The form element
 * @returns {string} The value of the selected builder, empty if the <select> doesn't exists
 * or nothing was selected.
 */
function getPreferredBuilder(form) {
  const preferredBuilderElem = form.querySelector('[data-preferred-builder]');
  const selectedBuilder = preferredBuilderElem
    ? preferredBuilderElem.options[preferredBuilderElem.selectedIndex].value
    : '';

  return selectedBuilder;
}

function getValidatedMpcId(mpcId) {
  return window.NewHomeSource.MpcEventsHelper.isVisitedMpc(mpcId)
    ? mpcId
    : 0;
}

function getFreeBrochureData(event, triggerElement) {
  var thisForm = event.target.classList.contains("getBrochureMinBtn")
    ? document.querySelector(".nhs_LeadForm")
    : event.target.closest("form");
  var formParent = jQuery(thisForm);
  var phoneField = thisForm.querySelector("[name='phone']");
  var dateSelected = thisForm.querySelector("[data-date]");
  var userPhone;
  var listingName = event.target.dataset.listingName;
  var disableBrochure = event.target.dataset.disableBrochure;

  if (phoneField) {
    userPhone = phoneField.length === 0
      ? ""
      : phoneField.value;
  }

  var parameters = JSON.parse(thisForm.querySelector("[data-form-parameters]").innerHTML);
  var includeSimilarCheckbox = thisForm.querySelector("[data-include-similar]");
  const isLimitedAvailability = !!document.querySelector('[data-limited-availability-banner]');
  const leadEvents = window.NewHomeSource.Modules.tagManager.getFromDataLayer('leadEvents') || {};
  const sendFormButton = thisForm.querySelector('[data-send-form]');
  window.NewHomeSource.GuidGenerator.leadGuid = window.NewHomeSource.GuidGenerator.generateGUID();

  var data = {
    ...leadEvents,
    // input fields
    Comments: addDataInComment(thisForm),
    Date: dateSelected ? dateSelected.getAttribute("data-date") : undefined,
    PreferredBuilder: getPreferredBuilder(thisForm),
    PreferredContactDetail: '',
    PreferredContactMethod: getPreferredContactMethod(thisForm),
    RealtorQuestionAnswerId: getRealtorQuestionAnswerId(thisForm),
    LiveOutside: thisForm.querySelector("[name='live-outside']").checked,
    MailAddress: thisForm.querySelector("[name='email']").value,
    Name: thisForm.querySelector("[name='name']").value,
    UserPhoneNumber: userPhone,
    UserPostalCode: thisForm.querySelector("[name='postal']").value,
    ZipCode: thisForm.querySelector("[name='postal']").value,
    // form parameters
    BuilderId: parameters.BuilderId,
    BuilderName: parameters.BrandName || parameters.BuilderName,
    CommunityId: parameters.CommunityId,
    CreditScoreText: parameters.CreditScoreText,
    IsAskQuestion: parameters.IsAskQuestion || thisForm.parentElement.getAttribute("data-panel-form-type") === 'contactBuilder',
    IgnoreComingSoonValidation: document.getElementById("IgnoreComingSoonValidation")
      ? document.getElementById("IgnoreComingSoonValidation").value === "True"
      : false,
    IsAddMeToInterestList: thisForm.querySelector("#IsAddMeToInterestList") ? thisForm.querySelector("#IsAddMeToInterestList").value : false,
    IsBuilderShowcase: false,
    IsComingSoon : parameters.IsComingSoon,
    WasMatchedAsSpotlightResult: parameters.WasMatchedAsSpotlightResult,
    IsComunityDetailV2: true,
    IsModalToSendEmail: thisForm.hasAttribute("data-onpage-form") !== true,
    IsGalleryXp: parameters.IsGalleryXp === "True",
    IsFullImageViewerLead: thisForm.parentElement.getAttribute("data-panel-form") !== null,
    IsLimitedAvailability: isLimitedAvailability,
    LeadAction: parameters.LeadAction || getLeadAction(thisForm),
    UseNewCommentFormat: true,
    IsMPCommunity: parameters.IsMPCommunity,
    IsPageCommDetail: parameters.IsPageCommDetail,
    IsPlan: parameters.IsPlan,
    ListingName: listingName,
    DisableBrochure: disableBrochure,
    MarketId: parameters.MarketId,
    NewSearchRCC: parameters.NewSearchRCC,
    NewUser: parameters.NewUser,
    ParentCommunityId: getValidatedMpcId(parameters.ParentCommunityId),
    PartnerUsesMatchmaker: parameters.PartnerUsesMatchmaker,
    PlanId: parameters.PlanId,
    SendAlerts: includeSimilarCheckbox &&
      includeSimilarCheckbox.checked,
    HasUserOptedIntoRecommendationEmail: includeSimilarCheckbox
      ? includeSimilarCheckbox.checked
      : null,
    ShowCreditScoreSection: parameters.ShowCreditScoreSection,
    ShowSaveToAccount: parameters.ShowSaveToAccount,
    ShowUserPhoneNumber: formParent.find("#nhs_ShowPhoneNumber").is(':visible'),
    SpecId: parameters.SpecId,
    SpotlightResultPosition: parameters.SpotlightResultPosition,
    IsOnPageForm: thisForm.hasAttribute("data-onpage-form"),
    GenerateLeadFrom: parameters.GenerateLeadFrom,
    FromPage: parameters.FromPage,
    ButtonNameSource: sendFormButton.getAttribute("data-ga4-identity-button_name") || undefined,
    Guid: window.NewHomeSource.GuidGenerator.leadGuid
  };

  return data;
}

function getAskQuestionData(event) {
  var thisForm = event.target.closest('form');
  const isLimitedAvailability = !!document.querySelector('[data-limited-availability-banner]');
  var parameters = JSON.parse(thisForm.querySelector("[data-form-parameters]").innerHTML);
  const leadEvents = window.NewHomeSource.Modules.tagManager.getFromDataLayer('leadEvents') || {};
  window.NewHomeSource.GuidGenerator.leadGuid = window.NewHomeSource.GuidGenerator.generateGUID();

  var data = {
    // input fields
    Comments: thisForm.querySelector("textarea").value,
    Email: thisForm.querySelector("[name='email']").value,
    MailAddress: thisForm.querySelector("[name='email']").value,
    LivesOutside: thisForm.querySelector("[name='live-outside']").checked,
    Name: thisForm.querySelector("[name='name']").value,
    Phone: thisForm.querySelector('[name=phone i]').value,
    UserPhoneNumber: thisForm.querySelector('[name=phone i]').value,
    PreferredBuilder: getPreferredBuilder(thisForm),
    RealtorQuestionAnswerId: getRealtorQuestionAnswerId(thisForm),
    Postal: thisForm.querySelector("[name='postal']").value,
    ZipCode: thisForm.querySelector("[name='postal']").value,
    // form parameters
    AppointmentDateTime: "",
    BuilderId: parameters.BuilderId,
    BuilderList: "",
    BuilderName: parameters.BuilderName,
    CommunityId: parameters.CommunityId,
    CommunityList: parameters.CommunityId,
    FromPage: parameters.FromPage,
    IsAddMeToInterestList: false,
    IsAppointment: false,
    IsAskQuestion: true,
    IsBuilderShowcase: false,
    IsCustomLocation: isCustomLocation,
    WasMatchedAsSpotlightResult: parameters.WasMatchedAsSpotlightResult,
    SpotlightResultPosition: parameters.SpotlightResultPosition,
    IsGalleryXp: parameters.IsGalleryXp === "True",
    IsFullImageViewerLead: thisForm.parentElement.getAttribute("data-panel-form") !== null,
    IsLimitedAvailability: isLimitedAvailability,
    IsMPCommunity: parameters.IsMPCommunity === "True",
    IsPageCommDetail: document.getElementById("LeadType").value === "com",
    IsPlan: parameters.IsPlan === "true",
    LeadAction: parameters.LeadAction,
    LeadFormType: "",
    LeadType: document.getElementById("LeadType").value,
    MarketId: parameters.MarketId,
    ParentCommunityId: getValidatedMpcId(parameters.ParentCommunityId),
    PlanId: parameters.PlanId,
    PlanList: "",
    RequestedFromGallery: false,
    ShowCalendar: false,
    ShowSaveToAccount: parameters.ShowSaveToAccount,
    SpecId: parameters.SpecId,
    SpecList: "",
    IsOnPageForm: thisForm.hasAttribute("data-onpage-form"),
    ...leadEvents,
    Guid: window.NewHomeSource.GuidGenerator.leadGuid
  }

  return data;
}

/**
  * throw the event to persona.js
  * @param {object} element Dom element with the data attributes required
*/
function sendSegmentEventFavorites(element) {
  if (!element || !window.NewHomeSource.UserCredentials) {
    return;
  }
  // if user is logged and if is free brochure, send the segment event
  const userSession = window.NewHomeSource.UserCredentials.isUserLogged() || false;

  if (userSession) {
    document.body.dispatchEvent &&
      document.body.dispatchEvent(new CustomEvent("trackIdentifySaveItems", {
        detail: { data: element }
      }));
  }
}

/**
* trackRealtorQuestionAnswerEvent: Tracks the sorted event for the realtor dropdown.
*/
function getRealtorQuestionAnswerText(event) {
  const form = event.target.classList.contains("getBrochureMinBtn")
    ? document.querySelector(".nhs_LeadForm")
    : event.target.closest("form");
  const realtorSelect = form.querySelector('[name="realtorquestion"]');
  let realtorQuestionAnswerText = '';
  if (realtorSelect && realtorSelect.selectedIndex > 0) {
    realtorQuestionAnswerText = realtorSelect.options[realtorSelect.selectedIndex].text;
  }
  return realtorQuestionAnswerText;
}

function sendFreeBrochureLead(event, formTriggeredElement, callback) {
  const data = getFreeBrochureData(event, formTriggeredElement);
  let requestUrl = document.getElementById("LeadUrl").value;
  let leadButtonClickedText = event.target.dataset.segmentButton_action;
  const isSchedulerParticipant = event.target.dataset.component === 'lead-by-iframe';
  const element = event.currentTarget;
  const onPageForm = formTriggeredElement.closest('[data-onpage-form]');

  jQuery.ajax(requestUrl, {
    method: 'GET',
    data: data,
    success: function (response) {
      if (typeof callback === 'function') {
        callback(data);
      }

      const container = document.querySelector('[data-trackers-container]');

      if (container) {
        const fragment = document.createRange().createContextualFragment(response);
        container.innerHTML = '';
        container.append(fragment);
        container.style.display = 'none';
      }


      if(onPageForm) {
        // hide the onpage brochure form to prevent duplicated leads for the same community.
        onPageForm.setAttribute('hidden', 'true');
      }
    }
  })

  cleanOpenFormButtons();

  const eventForSegment = {
    event: 'Lead Modal Form Submitted',
    eventType: 'segmentEvent',
    date: data.Date,
    tour_type: isSchedulerParticipant ? 'builder scheduled' : data.LeadAction,
    button_action: leadButtonClickedText,
    preferred_contact_method: data.PreferredContactMethod,
    realtor_question: getRealtorQuestionAnswerText(event),
  };

  if (onPageForm) {
    const activeTopicCheckedBoxes = formTriggeredElement.form
      ? Array.from(formTriggeredElement.form.querySelectorAll('[data-segment-topic]:checked'))
      : [];
    const topicList = activeTopicCheckedBoxes.map(checkboxElement => checkboxElement.dataset.comment);
    eventForSegment.lead_form_topics = topicList.join(', ');
    eventForSegment.event = 'On Page Lead Form Submitted';

    delete eventForSegment.tour_type;
  }

  let itemId = (data.CommunityId && data.CommunityId !== "0") ? `-c${data.CommunityId}` : '';
  if (data.SpecId && data.SpecId !== "0") {
    itemId += `-s${data.SpecId}`;
  }
  if (data.IsPlan === "true") {
    itemId += `-p${data.PlanId}`;
  }

  const sourceRequestKey = `${data.Guid}${itemId}`; 
  eventForSegment.source_request_key = sourceRequestKey;

  document.body.dispatchEvent &&
    document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
      detail: { data: eventForSegment }
    }));

  sendSegmentEventFavorites(element);

  // emit a new event with the response from the server.
  document.dispatchEvent(new CustomEvent("openRecommendedModal", {
    detail: { data: data }
  }));

  // check if the form exists, then focus it to have something to
  // return the focus back into.
  if(formTriggeredElement && formTriggeredElement.form){
    formTriggeredElement.form.focus();
  }

  const formData = {
    name: data.Name,
    emailAddress: data.MailAddress,
    phoneNumber: data.UserPhoneNumber,
    postalCode: data.UserPostalCode,
    livesOutside: data.LiveOutside,
    preferredContactMethod: data.PreferredContactMethod,
    realtorQuestionAnswer: data.RealtorQuestionAnswerId
  };
  fillInputsOnPageForm(formData);
}

function cleanOpenFormButtons() {
  if (window.NewHomeSource.ModalLoader) {
    window.NewHomeSource.ModalLoader.resetIsModalLoadedFlag();
  }
}

function sendAskQuestionLead(event, callback) {
  var data = getAskQuestionData(event);
  var leadButtonClickedText = event.target.dataset.segmentButton_action;
  const target = event.target;
  const onPageForm = target.closest('[data-onpage-form]');

  jQuery.ajax({
    type: "GET",
    url: document.getElementById("LeadUrl").value,
    data: data,
    dataType: "html",
    success: function (response) {
      cleanOpenFormButtons();
      const eventForSegment = {
        event: 'Lead Modal Form Submitted',
        date: data.Date,
        eventType: 'segmentEvent',
        button_action: leadButtonClickedText,
        realtor_question: getRealtorQuestionAnswerText(event),
      };

      document.body.dispatchEvent &&
        document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
          detail: { data: eventForSegment }
        }));

      sendSegmentEventFavorites(event.target);

      // emit a new event with the response from the server.
      document.dispatchEvent(new CustomEvent("openRecommendedModal", {
        detail: { data: data }
      }));

      if (typeof callback === 'function') {
        callback();
      }

      if(onPageForm) {
        // hide the onpage brochure form to prevent duplicated leads for the same community.
        onPageForm.setAttribute('hidden', 'true');
      }
    },
    error: function (error) {
      console.log(error);
    }
  });

  const formData = {
    name: data.Name,
    emailAddress: data.Email,
    phoneNumber: data.Phone,
    postalCode: data.Postal,
    livesOutside: data.LivesOutside,
    realtorQuestionAnswer: data.RealtorQuestionAnswerId
  };
  fillInputsOnPageForm(formData);
}

function fillInputsOnPageForm(formData) {
  document.body.dispatchEvent(new CustomEvent('onLeadPosted', {
    detail: formData
  }));
}

/**
 * Toggles the required attribute from the phone input when the preferred contact method is Phone or Text Message.
 * @param {object} event The event object after changing the preferred contact method dropdown.
 */
function onChangeContactMethod(event) {
  var selectedOption = event.target.options ? event.target.options[event.target.selectedIndex] : event.target;
  var selectedValue = selectedOption.value;
  var form = event.target.closest("form");
  var selectedOptions = form.querySelectorAll("#nhs-contact-method option:checked");
  var phoneInput = form.querySelector("[name='phone']");

  for (var i = 0; i < selectedOptions.length; i++) {
    selectedOptions[i].removeAttribute("selected");
    selectedOptions[i].removeAttribute("data-segment-identity-data");
  }

  selectedOption.setAttribute("selected", "");
  selectedOption.setAttribute("data-segment-event-preferred_contact_method", selectedValue);

  if ((selectedValue === "Phone" || selectedValue === "Text Message") &&
    !phoneInput.hasAttribute("required")) {
    phoneInput.setAttribute("required", "");
    phoneInput.placeholder = phoneInput.placeholder.replace(" (Optional)", "*");
    phoneInput.focus();
  }
  else if ((selectedValue !== "Phone" && selectedValue !== "Text Message") &&
    phoneInput.hasAttribute("required")) {
    phoneInput.removeAttribute("required");
    phoneInput.placeholder = phoneInput.placeholder.replace("*", " (Optional)");
  }
}

function onChangeRealtorAnswer(event) {
  let selectedOption = event.target.options ? event.target.options[event.target.selectedIndex] : event.target;
  if (event.target.options) {
    for (let element of event.target.options) {
      element.removeAttribute("selected");
    }
  }

  selectedOption.setAttribute("selected", "");
}

/**
 * Sets the events for the tabs in the form.
 */
function setupFormTabsEvents() {
  var selfGuidedTab = document.querySelectorAll("[data-nextStepModal] [data-selfGuidedTab]");
  var nonSelfGuidedTabs = document.querySelectorAll("[data-nextStepModal] [data-text-in-person], [data-nextStepModal] [data-is-virtual-tour]");

  if (nonSelfGuidedTabs) {
    for (var i = 0; i < nonSelfGuidedTabs.length; i++) {
      nonSelfGuidedTabs[i].addEventListener("click", function () {
        selfGuidedTourTabHandler(false, this.closest("[data-nextStepModal]"));
      });
    }
  }

  if (selfGuidedTab) {
    for (var i = 0; i < selfGuidedTab.length; i++) {
      selfGuidedTab[i].addEventListener("click", function () {
        selfGuidedTourTabHandler(true, this.closest("[data-nextStepModal]"));
      });

      if (selfGuidedTab[i].checked) {
        selfGuidedTourTabHandler(true, selfGuidedTab[i].closest("[data-nextStepModal]"));
      }
    }
  }
}

/**
 * Handles click events on the "Show More/Show Less" buttons
 * @param {event} event - Click event on the "Show More/Show Less"d toggle
 */
function showMoreClickHandler(event) {
  const target = event.target;
  const container = target.closest('[data-legal-text-container]');
  const truncated = container.classList.toggle('form__legal--truncated');
  target.textContent = truncated ? 'Show More' : 'Show Less';
}

/**
 * Sets up the "Show More" functionality
 * @param {Element} textElement
 */
function setupShowMoreLegalText(textElement) {
  const wrapper = textElement.closest('[data-legal-text-wrapper]');
  if (!wrapper) {
    // this check must be done while other legal disclaimers haven't been updated yet
    return;
  }
  const container = wrapper.querySelector('[data-legal-text-container]');
  const originalText = wrapper.querySelector('[data-legal-text]');

  // creating the text variations
  const text = originalText.innerText;
  const firstPeriodIndex = text.indexOf('. ');
  let truncatedText = text;

  // if there is a period, truncate the text to the first sentence
  if (firstPeriodIndex !== -1) {
    truncatedText = text.substring(0, firstPeriodIndex + 1);
  }

  originalText.classList.add('legal__text--expanded');

  const truncatedTextElement = document.createElement('span');
  truncatedTextElement.classList.add('legal__text--truncated');
  truncatedTextElement.textContent = truncatedText;

  // adding the element to the container
  container.appendChild(truncatedTextElement);

  container.appendChild(document.createTextNode(' '));

  // adding the show more button
  const button = document.createElement('span');
  button.textContent = 'Show More';
  button.addEventListener('click', showMoreClickHandler);
  button.setAttribute('role', 'button');
  button.classList.add('form__link');

  container.appendChild(button);

  container.classList.add('form__legal--truncated');
}

/**
 * Sets the events for the form.
 * @param {HTMLElement} form The form element.
 */
function setupLeadForms(form) {
  const phoneInput = form.querySelector('[name="phone"], [data-phone-input]');
  VMasker(phoneInput).maskPattern('(999) 999-9999');
  var internationalCheckbox = form.querySelector("[name=live-outside]");

  if (internationalCheckbox) {
    internationalCheckbox.onchange = onChangeToggleZipInput.bind(this, internationalCheckbox);
  }

  var sendFormButton = form.querySelector("[data-send-form]");

  if(sendFormButton) {
    sendFormButton.onclick = onClickSendForm;
  }

  var methodOfContactInput = form.querySelector("[data-contact-method]");
  let realtorQuestionAnswerInput = form.querySelector("[data-realtor-answer]");

  if (methodOfContactInput) {
    methodOfContactInput.addEventListener("change", function (event) {
      onChangeContactMethod(event);
    });
  }

  if (realtorQuestionAnswerInput) {
    realtorQuestionAnswerInput.addEventListener("change", function (event) {
      onChangeRealtorAnswer(event);
    });
  }

  /* Attaching events to the legal text elements present on the page on load */
  const legalTextElement = form.querySelector('[data-legal-text]');
  if (legalTextElement) {
    setupShowMoreLegalText(legalTextElement);
  }

  /* This is for the case when the text truncation and the show more button come
   * in the HTML to avoid layout shifts
   */
  const showMoreButton = form.querySelector('[data-legal-text-toggle]');
  if (showMoreButton) {
    showMoreButton.addEventListener('click', showMoreClickHandler);
  }

  setupFormTabsEvents();
}

function changeLeadAction(container){
  const radioOptions = container.querySelectorAll('input[type="radio"][name="radio-appointment"]');
  const target = Array.from(radioOptions).find(option => option.checked);

  const thisForm = target.classList.contains("getBrochureMinBtn")
    ? document.querySelector(".nhs_LeadForm")
    : target.closest("form");

  if (thisForm) {
    const parametersElement = thisForm.querySelector("[data-form-parameters]")
    const parameters = JSON.parse(parametersElement.innerHTML);

    parameters.LeadAction = target.dataset.leadAction;
    parametersElement.innerHTML = JSON.stringify(parameters);
  }
}

function initDatepickerGallery() {
  var phoneElement = document.getElementById("TrackingPhoneNumber");
  if (phoneElement) {
    var alertText = document.querySelector("[data-alert-not-available]").innerText;
    var container = document.getElementById("ui-datepicker-div");
    var datePicker = new Datepicker({
      queryElement: ".ui-datepicker-today",
      alertText: alertText
    });
    container.addEventListener("click", function () {
      datePicker.attachEventsToNotAvailableDay();
    });
    datePicker.attachEventsToNotAvailableDay();
  }
}

var tourInPersonVideoHandler = function (event) {
  const selfGuidedTab = document.querySelector("[data-sales-office-section] [data-selfGuidedTab]");
  if (selfGuidedTab) {
    selfGuidedTourTabHandler(false, document.querySelector("[data-sales-office-section]"));
  }
};

var createNewSlider = function(container) {
  var containerDatePicker = container.querySelector("[data-nextStepModal] [data-slider-component]");
  if (!containerDatePicker) {
    return;
  }

  let monthSlider = containerDatePicker.querySelector('[date-slider-role="month"]');
  if (monthSlider && monthSlider.innerHTML === "") {
    var startDate = window.startDate;
    var nextStepModal = document.querySelector("[data-nextStepModal]");
    var phone = document.querySelector("#TrackingPhoneNumber").value;
    if (DateSlider && nextStepModal) {
      var dayPicker = new DateSlider({
        container: containerDatePicker,
        firstDate: new Date(startDate).toISOString(),
        phone: phone,
        separator: '/'
      });

      dayPicker.onSetDay = function (date) {
        containerDatePicker.setAttribute("data-date", date);
      }
    }
  }
}

/**
 * selfGuidedTourTabHandler will update the modal to show the content the user is interested.
 * This content could be 1 on 1 form, remote video call form, or self guided tour form.
 *
 * @param {Boolean} showSelfGuidedTour a flag indicating if self guided tour needs to be shown.
 * @param {HTML} container offering the 3 distinct form options.

 */
const selfGuidedTourTabHandler = (showSelfGuidedTour, container) => {
    const formTourSections = container.querySelectorAll("[data-requestTourSection]");
    const externalTourSection = container.querySelector("[data-selfGuidedTourSection]");

    changeLeadAction(container);
    toggleGuidedTourTriggerAttributeToModalOpener(container, showSelfGuidedTour);

    if (!formTourSections || !externalTourSection) {
        createNewSlider(container);
        return;
    }

    if (showSelfGuidedTour) {
        externalTourSection.removeAttribute('hidden');
        const guidedTourCta = externalTourSection.querySelector('[data-utourlink]');
        const guidedTourCtaText = guidedTourCta ? guidedTourCta.innerText : "";
        updateLegalConsentText(container, guidedTourCtaText);

        formTourSections.forEach(section => section.setAttribute('hidden', ''));

        if (window.lazyLoad) {
            window.lazyLoad.init();
        }
    } else {
        externalTourSection.setAttribute('hidden', '');
        const regularTourCta = container.querySelector('[data-send-form]');
        const regularTourCtaText = regularTourCta ? regularTourCta.innerText : "";
        updateLegalConsentText(container, regularTourCtaText);

        formTourSections.forEach(section => section.removeAttribute('hidden'));
        createNewSlider(container);
    }
};

/**
 * updateLegalConsentText will update the legal consent text by providing the right button
 * text of the form the user is interested in submitting.
 * @param {HTML} container where the legal consent text is placed.
 * @param {string} buttonText to be read in the legal consent text.
 */
function updateLegalConsentText(container, buttonText) {
    const currentLegalConsentSection = container.querySelector('[data-first-legal-consent-section]');
    if (!currentLegalConsentSection) {
        return;
    }

    const template = document.querySelector('[data-first-legal-consent-section-template]');
    const clone = template.content.cloneNode(true);
    const clonedFirstLegalConsentSection = clone.querySelector('[data-first-legal-consent-section]');
    const updatedtLegalConsentText =
        clonedFirstLegalConsentSection.innerHTML.replace('the button', `the ${buttonText} button`);

    clonedFirstLegalConsentSection.innerHTML = updatedtLegalConsentText;
    currentLegalConsentSection.replaceWith(clonedFirstLegalConsentSection);
}

/**
 * @private
 *
 * toggleGuidedTourTriggerAttributeToModalOpener: supports the action of closing the form.
 * @param {HTML} container of the content that is going to be shown.
 * @param {boolean} isGoingToShowSelfGuidedContent true is self guided content is going to be shown, false otherwise.
 */
function toggleGuidedTourTriggerAttributeToModalOpener(container, isGoingToShowSelfGuidedContent) {
  const guidedTourConfiguration = document.querySelector('[data-guided-tour-configuration]');
  const modalTrigger = document.querySelector('[data-right-rails-modal]');
  if (!guidedTourConfiguration || !modalTrigger) {
    return;
  }
  const dataGuideTourSelector = guidedTourConfiguration.getAttribute('data-guided-tour-trigger');
  modalTrigger.removeAttribute(dataGuideTourSelector);
  if (dataGuideTourSelector !== '' && isGoingToShowSelfGuidedContent) {
    modalTrigger.setAttribute(dataGuideTourSelector, '');
  }
}

function initDatePicker(container) {
  var inPersonRadio = document.querySelector("#radio-in-person");
  var viaVideoRadio = document.querySelector("#radio-video");
  var phoneElement = document.querySelector("#TrackingPhoneNumber");
  var selfGuidedTab = document.querySelector("[data-sales-office-section] [data-selfGuidedTab]");
  var phone = phoneElement ? phoneElement.value : "";

  if (container) {
    var datePicker = new DateSlider({
      container: container,
      phone: phone,
      separator: '/'
    });
    datePicker.onSetDay = function (date) {
      container.setAttribute('data-date', date);
      var element = document.getElementById("nhs_RequestTour");

      if (element) {
        var buttonUrl = element.dataset.modalUrl;
        var dateParam = buttonUrl.indexOf("&date=");

        if (dateParam > 0) {
          element.dataset.modalUrl = buttonUrl.substring(0, dateParam);
        }

        element.dataset.modalUrl += "&date=" + date;
      }
    }
  }

  if (inPersonRadio) {
    inPersonRadio.addEventListener("change", tourInPersonVideoHandler);
  }

  if (viaVideoRadio) {
    viaVideoRadio.addEventListener("change", tourInPersonVideoHandler);
  }

  if (selfGuidedTab) {
    selfGuidedTab.addEventListener("click", function () {
      selfGuidedTourTabHandler(true, document.querySelector("[data-sales-office-section]"));
    });
  }
}


function attachFormEvents() {
  // ToDo: use mutation observer instead of jQuery to assign this dinamic element's events
  jQuery(document).on("click", "[data-utourlink]", function (event) {
    showThankYouPageForExternalLeads(event);
    cleanOpenFormButtons();
  });
}

$jq(document).ready(function () {
  const onPageForm = document.querySelector('[data-onpage-form]');
  setupLeadForms(onPageForm);
  attachFormEvents();
});
